import { useEffect, useState } from 'react';
import { eventTimes } from './constants';
import type EventManager from './EventManager';
import type { EventName } from './types';

export default function useEventTrigger(
  eventManager: EventManager,
  eventName: EventName
) {
  const [updateFlag, setUpdateFlag] = useState(eventTimes[eventName]);
  const [updateOffset, setUpdateOffset] = useState(0);

  useEffect(() => {
    function listener(whenToUpdate: number) {
      const now = Date.now();
      const offset = whenToUpdate > now ? whenToUpdate - now : 1;

      setUpdateOffset(offset);
    }

    eventManager.on(eventName, listener);

    return () => eventManager.off(eventName, listener);
  }, [eventManager, eventName]);

  useEffect(() => {
    if (!updateOffset) return () => {};

    const t = setTimeout(() => {
      setUpdateFlag(Date.now());
      setUpdateOffset(0);
    }, updateOffset);

    return () => clearTimeout(t);
  }, [updateOffset]);

  return updateFlag;
}
